import { cx } from '../../ui';

/**
 * S1-2: kit selection fill and row insets.
 *
 * THE SELECTED ROW IS GRAPHITE AS TODAY PLUS A SEMIBOLD LABEL (redesign register R-S4: "plus a
 * semibold label as the second cue"; L9: no glass). The weight is the product's semibold token
 * (`--weight-semibold` through Tailwind's `font-semibold`), keyed to `aria-current="page"`, which
 * every selected link row carries, so the rule outranks `.shell-nav-row`'s own weight whatever
 * order the two layers are emitted in.
 */
export const navItem = ({ isActive }: { readonly isActive: boolean }): string =>
  cx('shell-nav-row', isActive && 'shell-nav-row-selected aria-[current=page]:font-semibold');

/** The kit header is a small grey word, with neither a rule nor uppercase tracking. */
export const navSectionHeading = 'shell-nav-heading';
/**
 * THE GAP BEFORE A GROUP, AND IT HAS TO BE A MARGIN (wave 5 round 3, package A4). It was
 * `pt-5`, and `.shell-nav-heading` states the master's box as `block-size` - so with
 * border-box sizing the padding went inside the 20px header and separated nothing. The rule
 * and its kit line live in `index.css` beside the header itself.
 */
export const navSectionGap = 'shell-nav-group-gap';
/**
 * THE HEADER THAT FOLDS ITS GROUP (fulfillment wave, fix round 1). It is a button, so its
 * pressable box meets the touch floor; the rule in `index.css` grows the target from the top
 * of the group gap without moving a pixel of the drawing.
 */
export const navSectionDisclosure = 'shell-nav-disclosure';
